import React, { useState } from "react";
import { useWishlist } from "../context/WishlistContext";
import "./Shop.css";

const products = [
  {
    id: 1,
    title: "MultiFct B-7000 Multi-Purpose Adhesive (50ml Single Pack)",
    category: "Glue",
    price: 250,
    oldPrice: 500,
    discount: "50% off",
    rating: "4.9",
    reviews: 310,
    badge: "Bestseller",
    image: "/images/b7000-specs.jpg",
    description: "Precision metal needle nozzle with anti-clogging pin cap. Ideal for phone repair, DIY craft, jewelry & multi-surface bonding.",
  },
  {
    id: 2,
    title: "MultiFct B-7000 Adhesive (Pack of 2 Value Combo)",
    category: "Combo Pack",
    price: 450,
    oldPrice: 900,
    discount: "50% off",
    rating: "5.0",
    reviews: 184,
    badge: "Popular Value",
    image: "/images/b7000-pack-of-2.jpg",
    description: "Double pack of 50ml B-7000 adhesive. Best for frequent repair work, workshops and crafting studios.",
  },
  {
    id: 3,
    title: "MultiFct B-7000 Workshop Bulk Pack (Pack of 5)",
    category: "Bulk Pack",
    price: 999,
    oldPrice: 2200,
    discount: "55% off",
    rating: "4.9",
    reviews: 95,
    badge: "Best Value",
    image: "/images/b7000-pack-of-5.jpg",
    description: "Bulk pack of 5 x 50ml tubes. Premium clear industrial grade adhesive with needle tip.",
  },
  {
    id: 4,
    title: "MultiFct B-7000 Precision Repair & Craft DIY Kit",
    category: "Repair Kit",
    price: 349,
    oldPrice: 699,
    discount: "50% off",
    rating: "4.9",
    reviews: 142,
    badge: "New Arrival",
    image: "/images/b7000-repair-kit.jpg",
    description: "Complete DIY & phone screen repair kit with B-7000 adhesive tube, precision tweezers, pry tools, and needle cleaners.",
  },
];

const categories = ["All", "Glue", "Combo Pack", "Bulk Pack", "Repair Kit"];

const Shop = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");
  const { toggleWishlist, isInWishlist } = useWishlist();
  const whatsappNumber = "919727983039";

  const filteredProducts =
    selectedCategory === "All"
      ? products
      : products.filter((p) => p.category === selectedCategory);

  const handleWhatsAppOrder = (productTitle) => {
    const message = encodeURIComponent(
      `Hello, I would like to order: ${productTitle}`
    );
    window.open(`https://wa.me/${whatsappNumber}?text=${message}`, "_blank");
  };

  return (
    <div className="hm-shop-page">
      {/* Shop Header */}
      <section className="hm-shop-hero">
        <div className="hm-shop-hero-inner">
          <span className="hm-shop-tag">OUR CATALOG</span>
          <h1 className="hm-shop-title">Shop All Products</h1>
          <p className="hm-shop-subtitle">
            Explore our complete collection of high-strength B-7000 adhesives and
            precision repair kits.
          </p>

          {/* Filter Pills */}
          <div className="hm-category-pills">
            {categories.map((cat) => (
              <button
                key={cat}
                className={`hm-pill ${selectedCategory === cat ? "active" : ""}`}
                onClick={() => setSelectedCategory(cat)}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Products Grid */}
      <section className="hm-shop-grid-section">
        <div className="hm-shop-container">
          <div className="hm-products-grid">
            {filteredProducts.map((item) => {
              const isFav = isInWishlist(item.id);
              return (
                <div key={item.id} className="hm-shop-card">
                  {/* Badge */}
                  {item.badge && (
                    <span className="hm-card-status-badge">{item.badge}</span>
                  )}

                  {/* Wishlist Button */}
                  <button
                    className={`hm-shop-wishlist-btn ${isFav ? "active" : ""}`}
                    onClick={() => toggleWishlist(item)}
                    aria-label="Toggle Wishlist"
                  >
                    <svg
                      viewBox="0 0 24 24"
                      fill={isFav ? "#e03131" : "none"}
                      stroke={isFav ? "#e03131" : "currentColor"}
                      strokeWidth="2"
                    >
                      <path d="M20.8 4.6a5.5 5.5 0 0 0-7.8 0L12 5.7l-1.1-1.1a5.5 5.5 0 0 0-7.8 7.8l1.1 1.1L12 21l7.8-7.5 1.1-1.1a5.5 5.5 0 0 0-.1-7.8Z" />
                    </svg>
                  </button>

                  {/* Product Image */}
                  <div className="hm-shop-card-img-box">
                    <img
                      src={item.image}
                      alt={item.title}
                      className="hm-shop-card-img"
                    />
                  </div>

                  {/* Details */}
                  <div className="hm-shop-card-body">
                    <div className="hm-shop-card-rating">
                      <span className="hm-shop-stars">★★★★★</span>
                      <span className="hm-shop-rating-val">
                        {item.rating} ({item.reviews})
                      </span>
                    </div>

                    <h3 className="hm-shop-card-title">{item.title}</h3>
                    <p className="hm-shop-card-desc">{item.description}</p>

                    {/* Price */}
                    <div className="hm-shop-card-price-row">
                      <span className="hm-shop-current-price">₹{item.price}</span>
                      <span className="hm-shop-old-price">₹{item.oldPrice}</span>
                      <span className="hm-shop-discount-tag">{item.discount}</span>
                    </div>

                    {/* WhatsApp Order Button */}
                    <button
                      className="hm-shop-order-btn"
                      onClick={() => handleWhatsAppOrder(item.title)}
                    >
                      <svg
                        viewBox="0 0 24 24"
                        className="hm-shop-wa-icon"
                        fill="currentColor"
                      >
                        <path d="M20.5 3.5A11.7 11.7 0 0 0 12.1 0C5.6 0 .3 5.3.3 11.8c0 2.1.5 4.1 1.6 5.9L.2 24l6.4-1.7a11.8 11.8 0 0 0 5.5 1.4h.1c6.5 0 11.8-5.3 11.8-11.8 0-3.2-1.2-6.2-3.5-8.4ZM12.1 21.7c-1.8 0-3.6-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4a9.8 9.8 0 1 1 8.5 4.7Zm5.4-7.4c-.3-.2-1.7-.9-2-.9-.3-.1-.5-.2-.7.2-.2.3-.7.9-.9 1.1-.2.2-.3.2-.6.1-.3-.2-1.2-.5-2.3-1.5-.9-.8-1.5-1.7-1.7-2-.2-.3 0-.5.1-.6l.4-.5c.1-.2.2-.3.3-.5.1-.2 0-.4 0-.5-.1-.1-.6-1.5-.9-2-.2-.5-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4-.3.3-1 1-1 2.4s1 2.8 1.2 3c.1.2 2 3.2 5 4.5.7.3 1.2.5 1.7.6.7.2 1.3.2 1.8.1.6-.1 1.7-.7 2-1.4.2-.7.2-1.3.1-1.4-.1-.1-.3-.2-.6-.4Z" />
                      </svg>
                      Order on WhatsApp
                    </button>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Shop;
